import http from "@/http-credential";
// created by Cường
export default new class ManageDataService {
    findCapacityFromDB(tableName) {
        return http.get(`/data/controller?tableName=${tableName}`)
    }

    deleteCapacityFromDB(startDate, endDate, tableName) {
        return http.delete(`/data/controller?startDate=${startDate}&endDate=${endDate}&tableName=${tableName}`)
    }

    transferDataFromServerToS3(startDate, endDate, listIdSchool, checkDeleteS3_SV) {
        return http.get(`/s3/upload/transfer?startDate=${startDate}&endDate=${endDate}&checkDeleteS3_SV=${checkDeleteS3_SV}&listIdSchool=${listIdSchool}`)
    }

    getHistoryAction(codeAction) {
        return http.get(`/s3/upload/history-action?codeAction=${codeAction}`)
    }

    searchSchoolTransfer(deleteStatus, activated, nameSchool) {
        return http.get(`web/school/searchSchool/transfer/s3?deleteStatus=${deleteStatus}&activated=${activated}&nameSchool=${nameSchool}`);
    }

    deleteAlbumDataServerAndS3(startDate, endDate, listIdSchool) {
        return http.delete(`/s3/upload/delete/album-server-s3?startDate=${startDate}&endDate=${endDate}&listIdSchool=${listIdSchool}`)
    }

    getMessageAction(codeAction) {
        return http.get(`/s3/upload/message-action?codeAction=${codeAction}`)
    }

    getDeleteS3SVHandMade() {
        return http.get(`/s3/upload/delete-picture-hand-made`)
    }

    deleteRedundantPhotos(years, months,checkExitServer, listIdSchool) {
        return http.delete(`/s3/upload/delete/redundant-photos-server?years=${years}&months=${months}&checkExitServer=${checkExitServer}&listIdSchool=${listIdSchool}`)
    }

    scanPictureExitS3(startDate, endDate) {
        return http.get(`/s3/upload/scan-picture-exit-s3?startDate=${startDate}&endDate=${endDate}`)
    }

    restartConfiguration() {
        return http.get(`/s3/upload/restart-configuration`)
    }

    getReceiveMessagesSystem(){
        return http.get(`/s3/system-config/receive-messages-system`);
    }

    postReceiveMessagesSystem(phone) {
        return http.post(`/s3/system-config/receive-messages-system/create/${phone}`)
    }

    deleteReceiveMessagesSystem(id){
        return http.delete(`/s3/system-config/receive-messages-system/delete/${id}`);
    }

    findAllIconSystem(){
        return http.get(`/web/post-interaction/icons/all`);
    }
    createIconSystem(data){
        return http.post(`/web/post-interaction/icons/create`, data);
    }
    updateIconSystem(data){
        return http.post(`/web/post-interaction/icons/update`, data);
    }
    showIconSystem(idIcon, active){
        return http.get(`/web/post-interaction/icons/show`, {params:{idIcon,active}});
    }

    checkAndRunEnableDisableAttendanceOnDevice(){
        return http.get(`/web/webhook/change-auto-manual`)
    }

}